import { StatusActiveIcon } from '@tableau/icons/StatusActiveIcon';
import { StatusDownIcon } from '@tableau/icons/StatusDownIcon';
import { StatusErrorIcon } from '@tableau/icons/StatusErrorIcon';
import { StatusInProgressIcon } from '@tableau/icons/StatusInProgressIcon';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { NodeStatus } from './ClusterNodeStates';
import { ClusterNodeStatus } from './ClusterNodeStatus';

export type ClusterNodePresenceIconProps = Readonly<{
  status: ClusterNodeStatus;
  clusterNodeStatus: { readonly [s in ClusterNodeStatus]: NodeStatus };
}>;

export function ClusterNodePresenceIcon(props: ClusterNodePresenceIconProps) {
  const { status: state, clusterNodeStatus } = props;
  const label = (clusterNodeStatus[state] ?? clusterNodeStatus.Available).stateText;
  switch (state) {
    case ClusterNodeStatus.AVAILABLE:
      return <StatusActiveIcon className={statusIconClass} size={18} alt={label} />;
    case ClusterNodeStatus.UNACCEPTED:
      return <StatusDownIcon className={statusIconClass} size={18} alt={label} />;
    case ClusterNodeStatus.UNAVAILABLE:
      return <StatusErrorIcon className={statusIconClass} size={18} alt={label} />;
    case ClusterNodeStatus.PROVISIONING:
      return <StatusInProgressIcon className={statusIconClass} size={18} alt={label} />;
    default:
      return <StatusActiveIcon className={statusIconClass} size={18} alt={label} />;
  }
}

export const statusIconClass = style({
  verticalAlign: 'text-bottom',
  marginRight: TabStyles.Spacing.DefaultSpace
});
